<script>
  export let id = undefined
</script>

<!-- ロード中のクルクルマーク表示 -->
<div {id} data-testid={`${id ? id : ''}LoadingIndicator`}>
  <span class="icon"> <i class="fas fa-spinner fa-pulse" /> </span>
  <slot>loading...</slot>
</div>
